export default __webpack_public_path__ + "static/media/NotoSerif-BoldItalic.ecb903c6.woff2";